import React, { Component } from 'react';
import styled from 'styled-components';
import firebase from 'firebase';

import { Button, TextInput, TextArea } from './../lib/index';

const RootContainer = styled.div`
	background-color: #ffffff;
	border-radius: 5px;
	display: flex;
	padding: 20px;
	flex-direction: column;
`;

const HeadLine = styled.h1``;

const AddButton = styled.button`
	background-color: #56bc6f;
	border-radius: 5px;
	color: #ffffff;
	font-size: 20px;
	padding: 10px;
	width: 150px;
`;

const AddNewsModal = styled.div`
	align-items: center;
	background-color: #000000dd;
	bottom: 0;
	display: flex;
	height: 100vh;
	justify-content: center;
	left: 0;
	position: fixed;
	right: 0;
	top: 0;
	width: 100%;
	z-index: 99;
`;

const AddNewsCard = styled.div`
	background-color: #ffffff;
	border-radius: 5px;
	display: flex;
	flex-direction: column;
	max-width: 600px;
	padding: 20px;
	width: 100%;
	overflow: scroll;
	max-height: 600px;
`;

const ButtonRootContainer = styled.div`
	display: flex;
	justify-content: space-between;
`;

const ButtonContainer = styled.div`
	display: inline-flex;
	margin-bottom: 20px;
`;

const NewsItemRootContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
`;

const NewsItemContainer = styled.div`
	display: flex;
	width: 375px;
	background-color: #ffffff;
	box-shadow: 0px 0px 5px 0px #888888;
	flex-direction: column;
	margin-bottom: 50px;
`;

const NewsItemHeaderImage = styled.img`
	height: 50px;
	width: 50px;
	margin-bottom: 20px;
	display: block;
`;

const NewsTextContainer = styled.div`
	display: flex;
	flex-direction: column;
	padding: 20px;
	flex: 1;
	justify-content: space-between;
`;

const NewsItemTitle = styled.h3`
	color: #000000;
	margin-top: 0;
`;

const NewsItemBookingUrlContainer = styled.div`
	display: flex;
	justify-content: flex-end;
`;

const NewsItemBookingUrl = styled.a`
	display: inline-block;
	background-color: #edba5d;
	padding: 20px;
	color: #ffffff;
	border-radius: 5px;
	width: 100px;
	text-align: center;
`;

const NewsItemActionContainer = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
`;

const NewsItemActionButton = styled.button`
	background-color: ${(props) => (props.color ? props.color : '#edba5d')};
	border: none;
	color: #ffffff;
	display: inline-block;
	font-size: 20px;
	padding: 15px;
	width: 100px;
	border-radius: 5px;
	&:hover {
		background-color: ${(props) => (props.color ? props.color + 90 : '#edba5d')};
		cursor: pointer;
	}
`;

const ModalProgressContainer = styled.div`
	display: flex;
	position: fixed;
	top: 0;
	bottom: 0;
	right: 0;
	left: 0;
	background-color: #00000090;
	justify-content: center;
	align-items: center;
	z-index: 999;
`;

const ShowProgress = styled.div`
	height: 100px;
	width: 200px;
	background-color: #ffffff;
	color: #000000;
	display: flex;
	justify-content: center;
	align-items: center;
`;

const NewsItemDate = styled.h5`
	color: #6d7278;
	margin-top: 0;
`;

class OfferSub extends Component {
	constructor() {
		super();

		this.state = {
			infos: [],
			addModal: false,
			editModal: false,
			icon: '',
			filePath: '',
			iconHeight: '',
			iconWidth: '',
			order: '',
			textInfo: '',
			subtitle: '',
			title: '',
			upload: 0,
			editItemId: ''
		};
	}

	addNews = () => {
		const storageRef = firebase.storage().ref();
		// .ref(`offers/${this.state.filePath.name}`);
		const newMediaUpload = storageRef.child('offers').child(`${this.state.filePath.name}`);

		const upLoadTask = newMediaUpload.put(this.state.filePath);

		upLoadTask.on(
			'state_changed',
			(snapshot) => {
				const progress = snapshot.bytesTransferred / snapshot.totalBytes * 100;

				console.log('________prgress', progress);
				this.setState({ upload: progress });
			},
			(error) => {
				console.log('_____error', error);
			},
			() => {
				upLoadTask.snapshot.ref.getDownloadURL().then((url) => {
					console.log('_____url', url);

					const db = firebase.firestore();

					const ref = db.collection('offers').doc(this.props.match.params.id).collection('sub').add({
						icon: url,
						filePath: storageRef.fullPath,
						iconHeight: this.state.iconHeight,
						iconWidth: this.state.iconWidth,
						order: this.state.order,
						textInfo: this.state.textInfo,
						subtitle: this.state.subtitle,
						title: this.state.title
					});
					ref.then((data) => {
						const state = { ...this.state };
						state.infos = [];
						state.addModal = false;
						state.icon = '';
						state.filePath = '';
						state.iconHeight = '';
						state.iconWidth = '';
						state.order = '';
						state.textInfo = '';
						state.subtitle = '';
						state.title = '';
						state.upload = 0;
						this.setState(
							{
								...state
							},
							() => this.handleFetchNews()
						);
					});
				});
			}
		);
	};

	handleAddNewsModal = () => {
		this.setState({ addModal: !this.state.addModal });
	};

	handleChangeFile = (e) => {
		console.log('____e file', e.target.files[0]);

		this.setState({ filePath: e.target.files[0] });
	};

	handleChangeTextInput = (e, name) => {
		this.setState({ [name]: e.target.value });
	};

	removeNews = (id) => {
		if (window.confirm('Are you sure you want to remove this item?')) {
			console.log('______id', id);

			const db = firebase.firestore();
			const ref = db
				.collection('offers')
				.doc(this.props.match.params.id)
				.collection('sub')
				.doc(id)
				.delete()
				.then(() => {
					console.log('___removed news');
					this.handleFetchNews();
				})
				.catch((error) => {
					console.log('____error', error);
				});
		}
	};

	handleFetchNews = () => {
		const db = firebase.firestore();
		const ref = db.collection('offers').doc(this.props.match.params.id).collection('sub').get();

		const state = { ...this.state };
		state.infos = [];
		ref.then((snap) => {
			snap.forEach((doc) => {
				console.log('________doc', doc.data());

				const docItem = {
					infosId: doc.id,
					filePath: doc.data().filePath,
					icon: doc.data().icon,
					iconHeight: doc.data().iconHeight,
					iconWidth: doc.data().iconWidth,
					order: doc.data().order,
					subtitle: doc.data().subtitle,
					textInfo: doc.data().textInfo,
					title: doc.data().title
				};

				state.infos.push(docItem);
			});

			this.setState({ ...state });
		});
	};

	handleCancelEditItemModal = () => {
		const state = { ...this.state };
		state.editModal = false;
		state.icon = '';
		state.filePath = '';
		state.iconHeight = '';
		state.iconWidth = '';
		state.order = '';
		state.textInfo = '';
		state.subtitle = '';
		state.title = '';
		state.upload = 0;
		state.editItemId = '';
		this.setState({ ...state });
	};

	editItem = (itemId) => {
		const state = { ...this.state };
		const db = firebase.firestore();
		const ref = db.collection('offers').doc(this.props.match.params.id).collection('sub').doc(itemId).get();

		ref.then((doc) => {
			state.editModal = true;
			state.icon = doc.data().icon;
			state.filePath = '';
			state.iconHeight = doc.data().iconHeight;
			state.iconWidth = doc.data().iconWidth;
			state.order = doc.data().order;
			state.textInfo = doc.data().textInfo;
			state.subtitle = doc.data().subtitle;
			state.title = doc.data().title;
			state.upload = 0;
			state.editItemId = itemId;
			this.setState({ ...state });
		});
	};

	updateItem = () => {
		const state = { ...this.state };
		const db = firebase.firestore();

		const today = new Date();

		/* ---------------------- */

		if (!state.filePath == '') {
			const storageRef = firebase.storage().ref();
			// const storageRef = firebase
			//   .storage()
			//   .ref(`explore/${this.state.filePath.name}`);

			const newMediaUpload = storageRef
				.child('offers')
				.child(`${today.getTime()}`)
				.child(`${this.state.filePath.name}`);

			const upLoadTask = newMediaUpload.put(this.state.filePath);

			upLoadTask.on(
				'state_changed',
				(snapshot) => {
					const progress = snapshot.bytesTransferred / snapshot.totalBytes * 100;

					console.log('________prgress', progress);
					this.setState({ upload: progress });
				},
				(error) => {
					console.log('_____error', error);
				},
				() => {
					upLoadTask.snapshot.ref.getDownloadURL().then((url) => {
						console.log('_____url', url);

						const db = firebase.firestore();
						const ref = db
							.collection('offers')
							.doc(this.props.match.params.id)
							.collection('sub')
							.doc(this.state.editItemId)
							.update({
								filePath: upLoadTask.location_.path_,
								icon: url,
								iconHeight: this.state.iconHeight,
								iconWidth: this.state.iconWidth,
								order: this.state.order,
								textInfo: this.state.textInfo,
								subtitle: this.state.subtitle,
								title: this.state.title
							});
						ref.then((data) => {
							const state = { ...this.state };
							state.editModal = false;
							state.icon = '';
							state.filePath = '';
							state.iconHeight = '';
							state.iconWidth = '';
							state.order = '';
							state.textInfo = '';
							state.subtitle = '';
							state.title = '';
							state.upload = 0;
							state.editItemId = '';
							this.setState(
								{
									...state
								},
								() => this.handleFetchNews()
							);
						});
					});
				}
			);
		} else {
			const ref = db.collection('offers').doc(state.editItemId).update({
				iconHeight: this.state.iconHeight,
				iconWidth: this.state.iconWidth,
				order: this.state.order,
				textInfo: this.state.textInfo,
				subtitle: this.state.subtitle,
				title: this.state.title
			});
			ref.then((res) => {
				const state = { ...this.state };
				state.editModal = false;
				state.icon = '';
				state.filePath = '';
				state.iconHeight = '';
				state.iconWidth = '';
				state.order = '';
				state.textInfo = '';
				state.subtitle = '';
				state.title = '';
				state.upload = 0;
				state.editItemId = '';
				this.setState(
					{
						...state
					},
					() => this.handleFetchNews()
				);
			});
		}

		/* ---------------------- */
	};

	componentDidMount() {
		this.handleFetchNews();
	}

	render() {
		console.log('___props', this.props.match.params.id);

		return (
			<RootContainer>
				<HeadLine>Information</HeadLine>
				<ButtonContainer>
					<Button title="Add info" color="#56bc6f" onClick={() => this.handleAddNewsModal()} />
				</ButtonContainer>
				{this.state.infos.length > 0 ? (
					<NewsItemRootContainer>
						{this.state.infos.map((infoItem, index) => {
							return (
								<NewsItemContainer key={index}>
									<NewsItemHeaderImage src={infoItem.icon} />
									<NewsTextContainer>
										<NewsItemTitle>{infoItem.title}</NewsItemTitle>
										<NewsItemDate>Order : {infoItem.order}</NewsItemDate>
										<NewsItemDate>Height :{infoItem.iconHeight}</NewsItemDate>
										<NewsItemDate>Width : {infoItem.iconWidth}</NewsItemDate>
										<NewsItemDate>Subtitle : {infoItem.subtitle}</NewsItemDate>

										<NewsItemDate>
											Text info : {infoItem.textInfo.substring(0, 200) + '...'}
										</NewsItemDate>
										<NewsItemActionContainer>
											<NewsItemActionButton
												onClick={() => this.editItem(infoItem.infosId)}
												color="#03a9f4"
											>
												Edit
											</NewsItemActionButton>
											<NewsItemActionButton
												color="#ff0000"
												onClick={() => this.removeNews(infoItem.infosId)}
											>
												Remove
											</NewsItemActionButton>
										</NewsItemActionContainer>
									</NewsTextContainer>
								</NewsItemContainer>
							);
						})}
					</NewsItemRootContainer>
				) : null}
				{this.state.addModal ? (
					<AddNewsModal>
						<AddNewsCard>
							<HeadLine>Add information</HeadLine>
							<TextInput
								type="text"
								title="Title"
								value={this.state.title}
								onChange={(e) => this.handleChangeTextInput(e, 'title')}
							/>
							<TextInput
								type="text"
								title="Icon height"
								value={this.state.iconHeight}
								onChange={(e) => this.handleChangeTextInput(e, 'iconHeight')}
							/>
							<TextInput
								type="text"
								title="Icon Width"
								value={this.state.iconWidth}
								onChange={(e) => this.handleChangeTextInput(e, 'iconWidth')}
							/>
							<TextInput
								type="text"
								title="Order"
								value={this.state.order}
								onChange={(e) => this.handleChangeTextInput(e, 'order')}
							/>
							<TextInput
								type="text"
								title="Subtitle"
								value={this.state.subtitle}
								onChange={(e) => this.handleChangeTextInput(e, 'subtitle')}
							/>
							<TextArea
								type="text"
								title="Text info"
								value={this.state.textInfo}
								onChange={(e) => this.handleChangeTextInput(e, 'textInfo')}
							/>
							<TextInput type="file" title="Icon image" onChange={(e) => this.handleChangeFile(e)} />
							<ButtonRootContainer>
								<ButtonContainer>
									<Button title="Cancel" onClick={() => this.handleAddNewsModal()} />
								</ButtonContainer>
								<ButtonContainer>
									{this.state.upload > 0 ? (
										<ModalProgressContainer>
											<ShowProgress>Uploading : {this.state.upload.toFixed(1)} %</ShowProgress>
										</ModalProgressContainer>
									) : null}
									<Button title="Add" color="#56bc6f" onClick={() => this.addNews()} />
								</ButtonContainer>
							</ButtonRootContainer>
						</AddNewsCard>
					</AddNewsModal>
				) : null}

				{this.state.editModal ? (
					<AddNewsModal>
						<AddNewsCard>
							<HeadLine>Edit information</HeadLine>
							<TextInput
								type="text"
								title="Title"
								value={this.state.title}
								onChange={(e) => this.handleChangeTextInput(e, 'title')}
							/>
							<TextInput
								type="text"
								title="Icon height"
								value={this.state.iconHeight}
								onChange={(e) => this.handleChangeTextInput(e, 'iconHeight')}
							/>
							<TextInput
								type="text"
								title="Icon Width"
								value={this.state.iconWidth}
								onChange={(e) => this.handleChangeTextInput(e, 'iconWidth')}
							/>
							<TextInput
								type="text"
								title="Order"
								value={this.state.order}
								onChange={(e) => this.handleChangeTextInput(e, 'order')}
							/>
							<TextInput
								type="text"
								title="Subtitle"
								value={this.state.subtitle}
								onChange={(e) => this.handleChangeTextInput(e, 'subtitle')}
							/>
							<TextArea
								type="text"
								title="Text info"
								value={this.state.textInfo}
								onChange={(e) => this.handleChangeTextInput(e, 'textInfo')}
							/>
							<NewsItemHeaderImage src={this.state.icon} />
							<TextInput type="file" title="Icon image" onChange={(e) => this.handleChangeFile(e)} />
							<ButtonRootContainer>
								<ButtonContainer>
									<Button title="Cancel" onClick={() => this.handleCancelEditItemModal()} />
								</ButtonContainer>
								<ButtonContainer>
									{this.state.upload > 0 ? (
										<ModalProgressContainer>
											<ShowProgress>Uploading : {this.state.upload.toFixed(1)} %</ShowProgress>
										</ModalProgressContainer>
									) : null}
									<Button title="Update" color="#56bc6f" onClick={() => this.updateItem()} />
								</ButtonContainer>
							</ButtonRootContainer>
						</AddNewsCard>
					</AddNewsModal>
				) : null}
			</RootContainer>
		);
	}
}

export default OfferSub;
